/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBitcoin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 4h1.999V2h2v2h2V2h2v2H14c2.206 0 4 1.794 4 4a3.98 3.98 0 0 1-.864 2.48A5.004 5.004 0 0 1 20 15c0 2.757-2.243 5-5 5h-1.001v2h-2v-2h-2v2H8v-2H6zm9 8H8v6h7c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-1-6H8v4h6c1.103 0 2-.897 2-2s-.897-2-2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBitcoin as Bitcoin };
